import React, { useState, useEffect } from 'react'
import welcomePic from '../../../../assets/images/welcome.png';
import {
  getLanguages,
  setAppLanguageId,
  setSelectedAppLang,
  setEmailVerifiedAppLangId
} from '../../AxiosRtk/Miscellaneous';
import { useSelector, useDispatch } from 'react-redux';
import useLangTranslation from '../../../customHooks/languageProvider';
import { verifyEmail } from '../../AxiosRtk/Auth/AUTHCURD';
import { setShowInfo } from '../../AxiosRtk/successMessage/successMessageActions';
import { useHistory } from 'react-router-dom';

const EmailVerified = () => {
  const dispatch = useDispatch();
  const [data, setData] = useState({ email: '', token: '', language: 'en' });
  const { appSelectedLang } = useSelector(({ misc }) => misc);
  const { getLangTranslation } = useLangTranslation();

  const [ready, setReady] = useState(false);
  const history = useHistory();
  const isRTL = appSelectedLang?.IsRTL;

  const getLanguage = (token, languageLocalCode = 'en') => {
    getLanguages(token, languageLocalCode)
      .then((res) => {
        const langData = res?.data?.result?.find((el) => el?.LanguageLocalCode?.toLowerCase() === languageLocalCode?.toLowerCase());
        dispatch(setAppLanguageId(langData?.id))
        dispatch(setEmailVerifiedAppLangId(langData?.id))
        dispatch(setSelectedAppLang(langData))
      })
      .catch((error) => {
        console.log("getting languages catch error ==>>", error?.response?.data?.message);
      })
  };

  useEffect(() => {

    dispatch(setEmailVerifiedAppLangId(0))
    dispatch(setSelectedAppLang(null))

    const urlSearchString = window.location.search;
    const params = new URLSearchParams(urlSearchString);
    const langCode = params?.get('language');
    setData({
      email: params?.get('email'),
      token: params?.get('emailVerificatioToken'),
      language: langCode ? langCode : 'en'
    });
  }, [])

  useEffect(() => {
    if (data?.token) {
      getLanguage(data?.token, data?.language);
      setReady(true);
    }
  }, [data?.token])


  useEffect(() => {
    if (!ready) return;

    const payload = {
      email: data?.email,
      emailVerificatioToken: data?.token
    }

    verifyEmail(payload)
      .then((res) => {
        // dispatch(setShowEmailVerification(true))
      })
      .catch((err) => {
        dispatch(setShowInfo({
          showInfo: true,
          defaultTitle: "You are already verified",
          title: "ALREADY_VERIFIED"
        }))
      })
  }, [ready])

  if (isRTL >= 0) {
    return (
      <>
        <div className={`container ${isRTL === 1 ? 'rtl-direction' : ''}`}>
          <div className="card">
            <div className="card-body">
              <div className="content-550 mx-auto">
                <h1 className="text-center mb-6 text-blue-900">
                  {getLangTranslation("YOUR_FREE_TRIAL_HAS_START_EMAIL_VERIFIED_TITLE", "Your free trial has started. Now let’s get Kido Protect set up on your device")}
                </h1>
                <img className="img-fluid mb-6" src={welcomePic} alt="image" />
                <h4 className="text-gray mb-6">{getLangTranslation("WHATS_NEXT", "What’s Next")}</h4>
                <ul className={`timeline noLine light-marker mb-9 ${isRTL === 1 ? 'pe-0' : ''}`}>
                  <li className='align-items-start'>
                    <div>
                      <h3 className='text-blue-900'>{getLangTranslation("INSTALL_KIDO_PROTECT_ON_PARENT_DEVICE", "Install Kido Protect for Parents on your device")}</h3>
                      <h5 className='fw-normal'>{`${getLangTranslation("MONITOR_DEVICES", "Monitor devices")}, ${getLangTranslation("ADJUST_SETTINGS_APPROVE_REQUESTS_PARENT_DASHBOARD", "adjust settings and approve requests on the Parent dashboard")}, ${getLangTranslation("ALL_FROM_YOUR_SMARTPHONE", "all from your smartphone")}`}</h5>
                    </div>
                  </li>
                  <li className='pt-4 align-items-start'>
                    <div>
                      <h3 className='text-blue-900'>{getLangTranslation("INSTALL_KIDO_PROTECT_FOR_KIDS_ON_CHILD_DEVICE", "Install Kido Protect for kids on child’s device")}</h3>
                      <h5 className='fw-normal'>{getLangTranslation("MONITOR_PROTECT_YOUR_CHILD_DEVICE_EMAIL_VERIFIED", "Monitor and protect your child’s device(s). You’ll need access to your child’s device(s) to complete this part of the setup.")}</h5>
                    </div>
                  </li>
                  <li className='pt-4 align-items-start'>
                    <div>
                      <h3 className='text-blue-900'>{getLangTranslation("CUSTOMIZE_SETTINGS_FOR_CHILD_NEED_EMAIL_VERIFIED", "Customize the settings for your child’s needs")}</h3>
                      <h5 className='fw-normal'>{getLangTranslation("CREATE_UNIQUE_SETTINGS_FOR_EACH_CHILDREN", "Create unique settings for each of your children")}</h5>
                    </div>
                  </li>
                </ul>
                <div className='text-center'>
                  <button className='btn btn-primary content-400 w-100' onClick={() => history.push("/auth/login")}>
                    <span className='btn-upper-case'>{getLangTranslation("LETS_GET_STARTED", "Let’s get started")}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  return null;
}

export default EmailVerified